export default {
  documents: 'Documents',
  'documentSearch': 'Document Search',
};